// see app/Services/SitePrefixService.php for php source version
// this version has been adjusted slightly for front-end use
class SitePrefixService {
    constructor() {
        const parsedAppUrl = this.parseUrl(window.APP_URL)
        this.forceRelativePrefix = !parsedAppUrl.host
        this.reset()
    }

    apply(url, add) {
        // exclude certain scenarios
        if (!window.PREFIX) {
            return url
        }

        this.reset(url)

        // step 1: remove host part so we can deal with just the URI
        if (!this.removeHost()) {
            return url
        }

        // // step 2: note the slash and remove
        this.removeSlash()

        // // step 3: perform adding or removing the prefix
        this.addRemove(add)

        // // step 4: add back the domain or slash
        this.restoreExtraBeforePrefix()

        return this.url
    }

    reset(url = '') {
        this.url = url
        this.hadAppUrl = false
        this.hadStartingSlash = false
        this.urlDomain = ''
    }

    parseUrl(url) {
        const hostRegEx = /^((?:https?:)?\/\/)([^:\/?# \n]+)(.*)/
        const theRestRegEx = /^([\/]{0,1}[^?#]*)\??([^#]*|)#?(.*|)$/

        const parsedResult = {
            scheme: null,
            host: null,
            path: null,
            query: null,
            fragment: null,
            relativeUrl: null,
        }

        parsedResult.relativeUrl = url
        const matchDomain = hostRegEx.exec(url)
        if (matchDomain !== null) {
            parsedResult.scheme = matchDomain[1]
            parsedResult.host = matchDomain[2]

            parsedResult.relativeUrl = matchDomain[3]
        }

        const matchRest = theRestRegEx.exec(parsedResult.relativeUrl)
        if (matchRest !== null) {
            parsedResult.path = matchRest[1]
            parsedResult.query = matchRest[2]
            parsedResult.fragment = matchRest[3]
        }

        return parsedResult
    }

    removeHost() {
        const parsedUrl = this.parseUrl(this.url)
        if (parsedUrl.host) {
            this.urlDomain = parsedUrl.scheme + parsedUrl.host
            this.url = this.url.substr(this.urlDomain.length)
            this.hadAppUrl = true
        }

        return true
    }

    removeSlash() {
        if (this.url.startsWith('/')) {
            this.url = this.url.substr(1)
            this.hadStartingSlash = true
        }
    }

    addRemove(add) {
        const prefix = window.PREFIX
        const prefixWithSlash = `${prefix}/`

        if (add) {
            if (prefix !== this.url && !this.url.startsWith(prefixWithSlash)) {
                this.url = prefixWithSlash + this.url
            }
        } else {
            if (this.url.substr(0, prefixWithSlash.length) === prefixWithSlash) {
                this.url = this.url.substr(prefixWithSlash.length)
            }

            if (!this.url.length || this.url === prefix) {
                this.url = '/'
            }
        }
    }

    restoreExtraBeforePrefix() {
        if (this.hadAppUrl && !this.forceRelativePrefix) {
            this.url = `${this.urlDomain}/${this.url}`
        } else if ((this.hadStartingSlash || this.forceRelativePrefix) && !this.url.startsWith('/')) {
            this.url = `/${this.url}`
        }
    }
}

function url(payload) {
    const service = new SitePrefixService()
    return service.apply(payload, true)
}

function removeAppUrl(payload) {
    const service = new SitePrefixService()
    return service.apply(payload, false)
}

function forceRelativeUrl(payload) {
    const service = new SitePrefixService()
    const parsedUrl = service.parseUrl(payload)

    if (!parsedUrl.host) {
        return payload
    }

    return parsedUrl.relativeUrl
}

export { url, removeAppUrl, forceRelativeUrl }
